import { useMutation } from "@tanstack/react-query";

import { apiClient } from "@/api/client";
import type { components } from "@/api/schema";

export type LoginValues = components["schemas"]["LoginRequest"];
export type LoginResponse = components["schemas"]["LoginResponse"];

export function useLogin() {
  return useMutation({
    mutationFn: async (body: LoginValues) => {
      const { data, error } = await apiClient.POST("/v1/auth/login", { body });
      if (error) throw error;
      return data as LoginResponse;
    },
  });
}
